import React, { useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import dayjs from 'dayjs';
import { TextField, IconButton, InputAdornment, Box } from '@mui/material';
import styled from '@emotion/styled';

// Wrapper for controlling the overall layout of the input
const Wrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-width: 100px; /* Enforce max-width on the wrapper */
  width: 100%; /* Allow responsiveness */
`;

const StyledTextField = styled(TextField)`
  & .MuiInputBase-root {
    background-color: #f5f5f5; /* Light gray background */
    max-width: 100%; /* Ensure input does not exceed wrapper width */
  }

  & .MuiInputBase-input {
    padding: 10px; /* Adjust padding for better fit */
    text-align: center; /* Center-align the text */
  }
`;

const GenericTimePicker = ({ initialTime, onTimeChange }) => {
  const [selectedTime, setSelectedTime] = useState(dayjs(initialTime || new Date()));

  const handleTimeChange = (newTime) => {
    setSelectedTime(newTime);
    if (onTimeChange) {
      onTimeChange(newTime);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Wrapper>
        <MobileTimePicker
          value={selectedTime}
          onChange={handleTimeChange}
          ampm={false} // Use 24-hour format
          minutesStep={5} // Adjust step intervals
          // renderInput={(params) => (
          //   <StyledTextField
          //     {...params}
          //     InputProps={{
          //       ...params.InputProps
          //     }}
          //   />
        />
      </Wrapper>
    </LocalizationProvider>
  );
};

export default GenericTimePicker;
